import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

import { css, memoizeStyle, prefix } from "../../../lib/theming/Emotion";
import * as ColorFunctions from "../../../lib/styles/ColorFunctions";
export var globalClasses = prefix('token')({
  removeIcon: 'remove-icon'
});
export var styles = memoizeStyle({
  token: function token(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: inline-flex;\n      align-items: center;\n      border-radius: ", ";\n      padding: ", " ", ";\n      line-height: ", ";\n      font-size: ", ";\n      margin: ", " ", ";\n      min-width: 0;\n      word-break: break-all;\n      user-select: none;\n\n      &:hover {\n        cursor: pointer;\n      }\n    "])), t.tokenBorderRadius, t.tokenPaddingY, t.tokenPaddingX, t.tokenLineHeight, t.tokenFontSize, t.tokenMarginY, t.tokenMarginX);
  },
  disabled: function disabled(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      padding: ", " ", ";\n      margin: ", " ", ";\n      user-select: text;\n      cursor: text;\n      color: ", ";\n    "])), t.tokenPaddingYDisabled, t.tokenPaddingXDisabled, t.tokenMarginYDisabled, t.tokenMarginXDisabled, t.tokenTextColorDisabled);
  },
  text: function text(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      padding-bottom: ", ";\n    "])), t.tokenLegacyTextShift);
  },
  removeIcon: function removeIcon(t) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      height: ", ";\n      width: ", ";\n      flex-shrink: 0;\n      padding: ", " ", ";\n      box-sizing: ", ";\n      margin-left: ", ";\n      transition: none;\n      fill: currentColor;\n      opacity: 0.5;\n      line-height: 0;\n\n      &:hover {\n        opacity: 1;\n      }\n    "])), t.tokenRemoveIconSize, t.tokenRemoveIconSize, t.tokenRemoveIconPaddingY, t.tokenRemoveIconPaddingX, t.tokenRemoveIconBoxSizing, t.tokenRemoveIconGap);
  }
});
export var colorStyles = [{
  name: 'defaultIdle',
  color: function color(t) {
    return t.tokenDefaultIdle;
  }
}, {
  name: 'defaultActive',
  color: function color(t) {
    return t.tokenDefaultActive;
  }
}, {
  name: 'grayIdle',
  color: function color(t) {
    return t.tokenGrayIdle;
  }
}, {
  name: 'grayActive',
  color: function color(t) {
    return t.tokenGrayActive;
  }
}, {
  name: 'blueIdle',
  color: function color(t) {
    return t.tokenBlueIdle;
  }
}, {
  name: 'blueActive',
  color: function color(t) {
    return t.tokenBlueActive;
  }
}, {
  name: 'greenIdle',
  color: function color(t) {
    return t.tokenGreenIdle;
  }
}, {
  name: 'greenActive',
  color: function color(t) {
    return t.tokenGreenActive;
  }
}, {
  name: 'yellowIdle',
  color: function color(t) {
    return t.tokenYellowIdle;
  }
}, {
  name: 'yellowActive',
  color: function color(t) {
    return t.tokenYellowActive;
  }
}, {
  name: 'redIdle',
  color: function color(t) {
    return t.tokenRedIdle;
  }
}, {
  name: 'redActive',
  color: function color(t) {
    return t.tokenRedActive;
  }
}, {
  name: 'white',
  color: function color(t) {
    return t.tokenWhite;
  }
}, {
  name: 'black',
  color: function color(t) {
    return t.tokenBlack;
  }
}].reduce(function (colors, _ref) {
  var _extends2;

  var name = _ref.name,
      color = _ref.color;
  return _extends({}, colors, (_extends2 = {}, _extends2[name] = function (t, v) {
    var warning = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n        box-shadow: 0 0 0 ", " ", ", inset 0 0 0 1px ", ";\n      "])), t.tokenOutlineWidth, t.tokenBorderColorWarning, color(t));
    var error = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n        box-shadow: 0 0 0 ", " ", ", inset 0 0 0 1px ", ";\n      "])), t.tokenOutlineWidth, t.tokenBorderColorError, color(t));
    var vStyle = v === 'error' ? error : v === 'warning' ? warning : '';
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n        background-color: ", ";\n        color: ", ";\n        box-shadow: 0 0 0 ", " ", ", inset 0 0 0 1px ", ";\n\n        ", "\n\n        .", ":hover {\n          color: ", ";\n        }\n      "])), color(t), ColorFunctions.contrast(color(t)), t.tokenBorderWidth, ColorFunctions.darken(color(t), '5%'), color(t), vStyle, globalClasses.removeIcon, ColorFunctions.contrast(color(t)));
  }, _extends2));
}, {
  defaultDisabled: function defaultDisabled(t) {
    return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n        background-color: ", ";\n        box-shadow: ", ";\n\n        .", " {\n          fill: ", ";\n          opacity: 1;\n        }\n      "])), t.tokenDisabledBg, t.tokenShadowDisabled, globalClasses.removeIcon, t.tokenTextColorDisabled);
  },
  defaultDisabledWarning: function defaultDisabledWarning(t) {
    return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n        box-shadow: 0 0 0 ", " ", ", inset 0 0 0 1px ", ";\n      "])), t.tokenOutlineWidth, t.tokenBorderColorWarning, t.tokenDisabledBg);
  },
  defaultDisabledError: function defaultDisabledError(t) {
    return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n        box-shadow: 0 0 0 ", " ", ", inset 0 0 0 1px ", ";\n      "])), t.tokenOutlineWidth, t.tokenBorderColorError, t.tokenDisabledBg);
  }
});